import React, { useEffect } from 'react';
import { TextInputArea } from '@uhg-abyss/web/ui/TextInputArea';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useForm } from '@uhg-abyss/web/hooks/useForm';

const CharacterCount = styled('span', {
  fontWeight: 15,
  verticalAlign: 'bottom',
  fontSize: '12px',
  color: '$gray6',
  marginLeft: '3.5em',
});

export const RestrictionInput = () => {
  const form = useForm();
  useEffect(() => {}, []);

  const npiInfo = form.getValues('practiceInformation.restrictionInput');

  const handleOnChange = (value) => {
    form.setValue('practiceInformation.restrictionInput', value);
  };

  return (
    <React.Fragment>
      <TextInputArea
        id="restrictionTextField"
        label=" Please provide additional detail including provider names and license
            restrictions."
        model="practiceInformation.restrictionInput"
        aria-label="type info about Restriction here"
        rows={5}
        maxLength={500}
        validators={{
          required: (value) => {
            return !value ? 'This field is required if yes is selected.' : '';
          },
          invalid: (value) => {
            return !value.match(/[\dA-Za-z]+/g)
              ? 'This field is required if yes is selected.'
              : '';
          },
        }}
        css={{
          'abyss-text-input-area-root': {
            padding: '0 0.5625rem 0.7rem 0.825rem',
            borderRadius: '0.1875rem 0.1875rem 0 0',
            margin: '0 1rem 1rem 1rem',
          },
        }}
        onChange={(e) => {
          return handleOnChange(e.target.value);
        }}
        autoComplete="off"
      />

      <CharacterCount>
        {npiInfo ? npiInfo.length : 0}/500 Characters
      </CharacterCount>
    </React.Fragment>
  );
};

RestrictionInput.propTypes = {};

RestrictionInput.defaultProps = {};
